module.exports = __webpack_public_path__ + "img/logo-header.7bbad523.png";